import script from "./UserPasswordAdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPasswordAdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserPasswordAdminPanel.vue?vue&type=style&index=0&id=201bca6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201bca6c"]])

export default __exports__